import { render, staticRenderFns } from "./Traumgaben.vue?vue&type=template&id=18511d88&scoped=true&"
import script from "./Traumgaben.vue?vue&type=script&lang=js&"
export * from "./Traumgaben.vue?vue&type=script&lang=js&"
import style0 from "./Traumgaben.vue?vue&type=style&index=0&id=18511d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18511d88",
  null
  
)

export default component.exports